<template>
    <div class="flex min-h-106 flex-col items-center justify-center rounded-lg border border-border bg-surface p-6 text-center">
        <h2 class="body-serif text-ink">{{ t("connections.list.linkedProfiles.emptyTitle") }}</h2>
        <p class="body-small mt-1 max-w-md text-ink-muted">{{ t("connections.list.linkedProfiles.emptyHelp") }}</p>
        <BaseButton theme="neutral" size="sm" class="mt-4 flex items-center gap-2" data-testid="linked-profiles-add-from-organization" @click="emit('add-from-organization')">
            <i class="bi bi-plus-lg text-base/none" aria-hidden="true"></i>
            {{ t("connections.list.linkedProfiles.addColleagues") }}
        </BaseButton>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emit = defineEmits<{ "add-from-organization": [] }>();
</script>
